/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Current_LineInputs */



/**
* | output |
* | --- |
* | "Current line" |
*
* @param {Live_Caption_Current_LineInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_current_line = /** @type {((inputs?: Live_Caption_Current_LineInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Current_LineInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ligne actuelle")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktuelle Linie")
	if (locale === "it") return /** @type {LocalizedString} */ ("Linea corrente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Текущая линия")
	if (locale === "es") return /** @type {LocalizedString} */ ("Línea actual")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("当前线路")
	if (locale === "ja") return /** @type {LocalizedString} */ ("現在のライン")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्तमान रेखा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Linha atual")
	return /** @type {LocalizedString} */ ("Current line")
});